import { Record } from 'immutable';

const OutcomeRecord = new Record({
  id: null,
  contentType: 'bfb_impact_plan.outcome',
  comments: [],
  name: null,
  created: null,
  updated: null,
  project_sdg: null,
});

class Outcome extends OutcomeRecord {
  static contentType = 'bfb_impact_plan.outcome';

  get id() {
    return this.get('id');
  }
}

export default Outcome;
